import HttpClient from "../utils/http-client";

const cacheAllConfigurations = {};

export const ConfigurationKeys = {
  OFFLINE_MODE_ENABLED: "offline-mode-enabled",
  OFFLINE_MODE_DURATION: "offline-mode-duration",
  HEADSET_LOGO_URL: "ih-logo-url",
  SKIP_SIM_EXIT_POPUP: "skip-sim-exit-popup",
  DEVICE_LAST_ONLINE_ENABLED: "device-last-online-enabled",
  COURSE_BUILDER_ENABLED: "course-builder-enabled",
  AI_CURRICULUM_ENABLED: "ai-curriculum-enabled",
  IMPACT_REPORT_PROMPT_CONFIG_ENABLED: "impact-report-prompt-config-enabled",
  IMPACT_REPORT_ENABLED: "impact-report-enabled",
};

export const ConfigurationRequestKeys = {
  CONFIG_SETTINGS: "config_settings",
  WHITELISTED_URLS: "whitelisted_urls",
};

export class ConfigurationService extends HttpClient {
  async getOrganizationConfiguration(appId, organizationId) {
    return await this.http.get(`/config/${appId}`, {
      params: { organizationId },
    });
  }

  async getConfigurations(appId, role) {
    // Check if the configurations are already cached
    if (cacheAllConfigurations[role] && cacheAllConfigurations[role][appId]) {
      return cacheAllConfigurations[role][appId];
    }

    // Get the configurations from the API and cache them
    const response = await this.http.get(`/config/${appId}`);
    cacheAllConfigurations[role] = {
      ...cacheAllConfigurations[role],
      [appId]: response,
    };
    return response;
  }

  async uploadContent(appId, organizationId, content) {
    const formData = new FormData();
    formData.append("file", content);

    return await this.http.put(
      `/config/${appId}/organizations/${organizationId}/content`,
      formData,
    );
  }

  async updateOrganizationConfiguration(appId, organizationId, data) {
    return await this.http.put(`/config/${appId}`, data, {
      params: {
        organizationId,
      },
    });
  }
}
